import { AppBar } from "@kaizen-ui/complete";

function SearchHeader(): JSX.Element {
    return (
        <div style={{ top: "0" }}>
            <div style={{ paddingLeft: "12em" }}>
                <AppBar
                    app="Omniverse Kit Document Search"
                    appBarActions={<div></div>}
                    logoUrl="/"
                />
            </div>

            <div style={{ paddingLeft: "2em", paddingTop: "1em" }}>
                <div
                    style={{
                        alignItems: "center",
                        paddingLeft: "5em",
                        fontFamily: "'Roboto', sans-serif",
                        fontSize: "1.5rem",
                    }}
                >
                    <p>
                        Search all NVIDIA Omniverse Kit Developer Documentation
                    </p>
                </div>
            </div>
        </div>
    );
}

export { SearchHeader };
